import { render, staticRenderFns } from "./ConfigurationWorkshop.vue?vue&type=template&id=cb53dd5e&scoped=true&"
import script from "./ConfigurationWorkshop.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationWorkshop.vue?vue&type=style&index=0&id=cb53dd5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb53dd5e",
  null
  
)

export default component.exports